import React from 'react'
import classnames from 'classnames'
import styles from './AssetClass.module.scss'
import tooltipStyles from '../InfoTooltip/InfoTooltip.module.scss'

import PropTypes from 'prop-types'
import InfoTooltip from '../InfoTooltip/InfoTooltip'

const AssetClass = (props) => {
  const {
    percentage,
    classAllocationName,
    isUnassigned,
    testId,
  } = props

  const assetClassStyles = classnames(styles.AssetClass, {
    [styles.grayedOut]: percentage === 0,
  })

  const classAllocationStyles = classnames(styles.classAllocation, {
    [styles.unassignedMarginTop] : isUnassigned
  })
  const unassignedText = 'What\'s this?'

  return (
    <div className={assetClassStyles} data-test-id={testId}>
      <span className={styles.percentage}>
        {percentage}
        <span className={styles.symbol}>%</span>
      </span>
      <div className={classAllocationStyles}>
        <span className={styles.classAllocationName}>
          {classAllocationName}
        </span>
        {isUnassigned && (
          <InfoTooltip className={styles.tooltipWrapper} title={unassignedText}>
            <div className={tooltipStyles.tooltipContent}>
              <p className={tooltipStyles.header}>YOUR HOLDINGS ARE UNDER REVIEW</p>
              <p className={tooltipStyles.body}>Our investments team is currently reviewing
              these holdings and classifying them into the appropriate asset classes.
              When our review is complete, your holdings will be reflected
              under the corresponding asset class heading.
              </p>
            </div>
          </InfoTooltip>)
        }
      </div>
    </div>
  )
}

AssetClass.defaultProps = {
  isUnassigned: false,
}

AssetClass.propTypes = {
  percentage: PropTypes.number.isRequired,
  classAllocationName: PropTypes.string.isRequired,
  isUnassigned: PropTypes.bool,
  testId: PropTypes.string.isRequired,
}

export default AssetClass



// WEBPACK FOOTER //
// ./src/components/Client/AssetClass/AssetClass.jsx